module.exports = __webpack_public_path__ + "files/1788c44d1a60b365861dd3d5c6f95d20.svg";